import { render, staticRenderFns } from "./EncounterMedicationTable.vue?vue&type=template&id=55e761ae&"
import script from "./EncounterMedicationTable.vue?vue&type=script&lang=js&"
export * from "./EncounterMedicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports